<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import IMask from 'imask';
import BaseField from '@/components/BaseField.vue';

export const phoneMask = {
  mask: '+{7}(000)000-0000',
  prepare: (appended, masked) => {
    if (appended === '8' && masked.value === '') {
      return '';
    }
    return appended;
  },
};

export const parsePhone = (value) => {
  const mask = IMask.createMask(phoneMask);
  return mask.resolve(value);
};

export default {
  name: 'FieldPhone',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  staticData: () => ({
    mask: phoneMask,
  }),
  computed: {
    placeholder() {
      if (!this.$attrs.value) return this.$t('fields.phonePlaceholder');
      const postfix = '+7(___)___-____'.substring(this.$attrs.value.length);
      return this.$attrs.value + postfix;
    },
    attributes() {
      return {
        type: 'tel',
        label: this.$t('fields.phoneLabel'),
        errorMessage: this.$t('fields.phoneError'),
        inputPlaceholder: this.placeholder,
        maskOptions: this.mask,
        valueValidator: (value) => value !== '' && value !== '+7',
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
  },
};
</script>
